var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "md-layout md-alignment-center-right",
      class: { "editable-input-field__nowrap": _vm.nowrap }
    },
    [
      [
        _c(
          "md-field",
          {
            staticClass: "field",
            class: {
              fieldClass: _vm.fieldClass,
              "without-pseudoclasses": !_vm.allowToEdit
            },
            attrs: {
              inline: _vm.inline,
              clearable: _vm.clearable,
              togglePassword: _vm.togglePassword
            }
          },
          [
            _c("label", { attrs: { for: _vm.id } }, [
              _vm._v(_vm._s(_vm.label))
            ]),
            _vm._v(" "),
            _c("md-input", {
              ref: "input",
              class: "text-align-" + _vm.align,
              attrs: {
                id: _vm.id,
                type: _vm.type,
                name: _vm.name,
                value: _vm.currentValue,
                counter: _vm.counter,
                required: _vm.required,
                maxlength: _vm.maxlength,
                placeholder: _vm.placeholder,
                disabled: !_vm.allowToEdit,
                readonly: _vm.readonly,
                min: _vm.min,
                max: _vm.max,
                step: _vm.step
              },
              on: { input: _vm.onInput, blur: _vm.onBlur }
            }),
            _vm._v(" "),
            _vm.errorMessage
              ? _c("span", { staticClass: "md-error" }, [
                  _vm._v(_vm._s(_vm.errorMessage))
                ])
              : _vm._e()
          ],
          1
        )
      ],
      _vm._v(" "),
      _vm.showIcons
        ? [
            _c(
              "div",
              { staticClass: "edit" },
              [
                !_vm.allowToEdit
                  ? _c(
                      "md-button",
                      {
                        staticClass: "md-icon-button",
                        attrs: { disabled: !_vm.canBeEditable },
                        on: { click: _vm.startEdit }
                      },
                      [
                        _c(
                          "md-icon",
                          {
                            style: _vm.iconSize
                              ? "font-size: " + _vm.iconSize + "px !important"
                              : ""
                          },
                          [_vm._v("edit")]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.allowToEdit
                  ? [
                      _c(
                        "div",
                        {
                          staticClass: "md-layout",
                          class: { "editable-input-field__nowrap": _vm.nowrap }
                        },
                        [
                          _c(
                            "md-button",
                            {
                              staticClass: "md-icon-button",
                              on: { click: _vm.changeValue }
                            },
                            [
                              _c(
                                "md-icon",
                                {
                                  style: _vm.iconSize
                                    ? "font-size: " +
                                      _vm.iconSize +
                                      "px !important"
                                    : ""
                                },
                                [_vm._v("done")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "md-button",
                            {
                              staticClass: "md-icon-button",
                              on: { click: _vm.finishEdit }
                            },
                            [
                              _c(
                                "md-icon",
                                {
                                  style: _vm.iconSize
                                    ? "font-size: " +
                                      _vm.iconSize +
                                      "px !important"
                                    : ""
                                },
                                [_vm._v("clear")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  : _vm._e()
              ],
              2
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a452e28", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a452e28","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/common/fields/EditableInputField.vue
// module id = mj7n
// module chunks = 1